import {
  GOOGLE,
  LINKEDIN,
  META,
  TIKTOK,
} from "../../../../i18n/keysTranslations";
import {
  COUNTRIES,
  GOOGLE as GOOGLE_PLATFORM,
  LINKEDIN as LINKEDIN_PLATFORM,
  META as META_PLATFORM,
  TIKTOK as TIKTOK_PLATFORM,
} from "../../../../utils/constants";
import { getIntlLocaleCode } from "../../../../utils/i18nLanguage";

const AD_SPEND_PLATFORM_LABEL = {
  [META_PLATFORM]: META,
  [GOOGLE_PLATFORM]: GOOGLE,
  [TIKTOK_PLATFORM]: TIKTOK,
  [LINKEDIN_PLATFORM]: LINKEDIN,
};

const COUNTRY_LABEL_BY_CODE = new Map(
  COUNTRIES.map((country) => [country.value, country.label])
);

const flagEmoji = (countryCode) => {
  if (!countryCode || countryCode.length !== 2) return "";
  const points = [...countryCode.toUpperCase()].map(
    (char) => 127397 + char.charCodeAt(0)
  );
  return String.fromCodePoint(...points);
};

export const formatAdSpendCountry = ({ countryCode, t }) => {
  if (!countryCode) return "";
  const labelKey = COUNTRY_LABEL_BY_CODE.get(countryCode);
  return `${flagEmoji(countryCode)} ${labelKey ? t(labelKey) : countryCode}`;
};

export const formatAdSpendPlatform = ({ platform, t }) =>
  t(AD_SPEND_PLATFORM_LABEL[platform] || platform);

const NUMBER_FORMAT_OPTIONS = {
  money: {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    // "always" keeps the separator on 4-digit amounts in es/pt (1.234,50).
    useGrouping: "always",
  },
  compactMoney: { notation: "compact", maximumFractionDigits: 1 },
  axis: { maximumFractionDigits: 0, useGrouping: "always" },
  percent: { style: "percent", maximumFractionDigits: 1 },
};

const numberFormatters = new Map();

const getNumberFormatter = ({ language, kind }) => {
  const locale = getIntlLocaleCode(language);
  const cacheKey = `${locale}:${kind}`;
  if (!numberFormatters.has(cacheKey)) {
    numberFormatters.set(
      cacheKey,
      new Intl.NumberFormat(locale, NUMBER_FORMAT_OPTIONS[kind])
    );
  }
  return numberFormatters.get(cacheKey);
};

// Single USD format for the report: locale digits plus the ISO code, no "$".
export const formatAdSpendUsd = ({ value, language, compact = false }) =>
  `${getNumberFormatter({
    language,
    kind: compact ? "compactMoney" : "money",
  }).format(Number(value) || 0)} USD`;

export const formatAdSpendAxis = ({ value, language }) =>
  getNumberFormatter({ language, kind: "axis" }).format(Number(value) || 0);

export const formatAdSpendPercent = ({ percent, language }) =>
  getNumberFormatter({ language, kind: "percent" }).format(
    (Number(percent) || 0) / 100
  );

export const AD_SPEND_CARD_SX = {
  backgroundColor: "#ffffff",
  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  border: "1px solid #e5e7eb",
};

// The pie tooltip sits on a transparent Recharts wrapper. Force the same
// white surface the investment evolution chart already uses.
export const AD_SPEND_CHART_TOOLTIP_SX = {
  "& .recharts-tooltip-wrapper": {
    outline: "none",
    zIndex: 10,
  },
  "& .recharts-default-tooltip": {
    backgroundColor: "#FFFFFF !important",
    border: "1px solid #E5E5E5 !important",
    borderRadius: "12px !important",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18) !important",
  },
  "& .recharts-tooltip-wrapper .rounded-lg": {
    backgroundColor: "#FFFFFF !important",
  },
};
